function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.333,
    height: 21,
    viewBox: "0 0 22.333 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25985"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25516"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24861",
    d: "m12615.594 417.092 3.055.875 3.625 7.813-5.273-1.736-5.546 1.736-5.508-1.736-5.483 1.736 4.225-7.813 2.625-.875z",
    transform: "translate(-12600.277 -405.224)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25504"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24848",
    d: "M30.132 14.888a.447.447 0 0 1-.447-.447 5.056 5.056 0 0 0-10.112 0 .447.447 0 1 1-.893 0 5.949 5.949 0 0 1 11.9 0 .447.447 0 0 1-.448.447z",
    transform: "translate(-13.463 -8.492)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25505"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24849",
    d: "M50.549 44.8a.447.447 0 0 1-.4-.243L46.2 36.8a.447.447 0 1 1 .8-.406l3.953 7.751a.446.446 0 0 1-.4.649z",
    transform: "translate(-28.663 -23.799)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25506"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24850",
    d: "M7.446 44.8a.446.446 0 0 1-.4-.649L11 36.4a.447.447 0 1 1 .8.406l-3.956 7.749a.447.447 0 0 1-.398.245z",
    transform: "translate(-7 -23.799)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25507"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24851",
    d: "M28.886 51.967a.454.454 0 0 1-.154-.028l-5.206-1.909-5.206 1.909a.449.449 0 0 1-.307 0l-5.207-1.909L7.6 51.939a.447.447 0 0 1-.307-.839l5.36-1.965a.449.449 0 0 1 .307 0l5.206 1.909 5.206-1.909a.449.449 0 0 1 .307 0l5.36 1.965a.447.447 0 0 1-.154.867z",
    transform: "translate(-7 -30.967)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25508"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24852",
    d: "M31.892 30.221a.446.446 0 0 1-.4-.65 15.211 15.211 0 0 1 2.343-3.126c.322-.36.644-.719.95-1.089a6.653 6.653 0 0 0 1.961-4.1.447.447 0 0 1 .447-.446.447.447 0 0 1 .446.448 7.5 7.5 0 0 1-2.166 4.665c-.314.379-.644.747-.973 1.115a14.331 14.331 0 0 0-2.214 2.938.446.446 0 0 1-.394.245z",
    transform: "translate(-20.527 -15.309)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25509"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24853",
    d: "M24.43 30.221a.447.447 0 0 1-.4-.243 14.3 14.3 0 0 0-2.214-2.938c-.329-.368-.659-.736-.973-1.115a7.5 7.5 0 0 1-2.166-4.665.447.447 0 0 1 .446-.448.447.447 0 0 1 .447.446 6.653 6.653 0 0 0 1.961 4.1c.307.37.629.73.95 1.089a15.227 15.227 0 0 1 2.343 3.126.446.446 0 0 1-.4.65z",
    transform: "translate(-13.463 -15.309)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25510"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24854",
    d: "M31.2 40.89a.666.666 0 0 1-.6-.364.447.447 0 0 1 .6-.6.447.447 0 0 1 .6.6.666.666 0 0 1-.6.364z",
    transform: "translate(-20.034 -25.858)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25511"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24855",
    d: "M31.447 49.223a.447.447 0 0 1-.447-.447V44.6a.447.447 0 1 1 .893 0v4.179a.447.447 0 0 1-.446.444z",
    transform: "translate(-20.281 -28.223)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25512"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24856",
    d: "M16.3 35.977a.447.447 0 0 1-.154-.866l2.357-.864a.447.447 0 1 1 .307.839l-2.357.864a.441.441 0 0 1-.153.027z",
    transform: "translate(-11.898 -22.729)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25513"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24857",
    d: "M19.447 42.734a.435.435 0 0 1-.121-.017.446.446 0 0 1-.309-.551l1.65-5.865a.446.446 0 1 1 .859.242l-1.65 5.865a.447.447 0 0 1-.429.326z",
    transform: "translate(-13.64 -23.7)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25514"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24858",
    d: "M41.4 42.734a.447.447 0 0 1-.43-.326l-1.65-5.865a.446.446 0 1 1 .859-.242l1.65 5.865a.446.446 0 0 1-.309.551.423.423 0 0 1-.121.017z",
    transform: "translate(-24.877 -23.7)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25515"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24859",
    d: "M43.675 35.977a.443.443 0 0 1-.154-.028l-2.357-.864a.447.447 0 1 1 .307-.839l2.357.864a.447.447 0 0 1-.154.867z",
    transform: "translate(-25.744 -22.728)",
    style: {
      fill: "#393939"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 2522",
    transform: "translate(8.723 2.776)",
    style: {
      fill: "#fff",
      stroke: "#393939"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    style: {
      fill: "none"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e16f6207aacab2b891cfe22236f7543f.svg";
export { ForwardRef as ReactComponent };